import './green-bean.module.css';

export const GreenBeanTheme = 'green-bean';
